import {Button as ButtonAntd, ButtonProps} from 'antd';
import './index.style.less';

export declare type ButtonColors = 'green' | 'blue' | 'black';

interface IButtonProps extends Omit<ButtonProps, 'color'> {
  color?: ButtonColors;
}

const Button = (props: IButtonProps) => {
  const { color, className, children, ...rest } = props;
  return (
    <ButtonAntd
      {...rest}
      className={`button-basic ${className ?? ''} ${color ?? ''}`}>
      {children}
    </ButtonAntd>
  );
};
export default Button;
